function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isCountingAggregateOp } from '../../../aggregate';
import { getFieldDef, vgField } from '../../../channeldef';
import { isScaleInvalidDataIncludeAsValue } from '../../../invalid';
import { fieldValidPredicate } from '../../../predicate';
import { isSignalRef } from '../../../vega.schema';
import { getScaleInvalidDataMode } from '../../invalid/ScaleInvalidDataMode';
import { scaledZeroOrMinOrMax } from './scaledZeroOrMinOrMax';
export function getConditionalValueRefForIncludingInvalidValue(_ref) {
  var scaleChannel = _ref.scaleChannel,
    channelDef = _ref.channelDef,
    scale = _ref.scale,
    scaleName = _ref.scaleName,
    markDef = _ref.markDef,
    config = _ref.config;
  var scaleType = scale === null || scale === void 0 ? void 0 : scale.get('type');
  var fieldDef = getFieldDef(channelDef);
  var isCountAggregate = isCountingAggregateOp(fieldDef === null || fieldDef === void 0 ? void 0 : fieldDef.aggregate);
  var invalidDataMode = getScaleInvalidDataMode({
    scaleChannel: scaleChannel,
    markDef: markDef,
    config: config,
    scaleType: scaleType,
    isCountAggregate: isCountAggregate
  });
  if (fieldDef && invalidDataMode === 'show') {
    var _config$scale$invalid, _config$scale$invalid2;
    var includeAs = (_config$scale$invalid = (_config$scale$invalid2 = config.scale.invalid) === null || _config$scale$invalid2 === void 0 ? void 0 : _config$scale$invalid2[scaleChannel]) !== null && _config$scale$invalid !== void 0 ? _config$scale$invalid : 'zero-or-min';
    return _objectSpread({
      test: fieldValidPredicate(vgField(fieldDef, {
        expr: 'datum'
      }), false)
    }, refForInvalidValues(includeAs, scale, scaleName));
  }
  return undefined;
}
function refForInvalidValues(includeAs, scale, scaleName) {
  if (isScaleInvalidDataIncludeAsValue(includeAs)) {
    var value = includeAs.value;
    return isSignalRef(value) ? {
      signal: value.signal
    } : {
      value: value
    };
  }
  return scaledZeroOrMinOrMax({
    scale: scale,
    scaleName: scaleName,
    mode: 'zeroOrMin'
  });
}